import { render } from "./ValueAddModal.vue?vue&type=template&id=edade45a&scoped=true"
import script from "./ValueAddModal.vue?vue&type=script&lang=js"
export * from "./ValueAddModal.vue?vue&type=script&lang=js"

import "./ValueAddModal.vue?vue&type=style&index=0&id=edade45a&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edade45a"]])

export default __exports__